export default __webpack_public_path__ + "static/media/730.51919061.png";